const PageContainer = ({ pc, h5, isH5 }) => {
  return <>{isH5 ? h5 : pc}</>;
};

export default PageContainer;